import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { shouldSkipMarketplaceScroll } from "@/hooks/useMarketplaceState";

// Routes that support scroll restoration
const SCROLL_RESTORE_ROUTES = ["/ispai-solutions", "/channel-solutions"];

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Check if we should skip scroll for marketplace routes returning from navigation
    const isMarketplaceRoute = SCROLL_RESTORE_ROUTES.some(route => pathname.startsWith(route));
    
    if (isMarketplaceRoute && shouldSkipMarketplaceScroll()) {
      // Skip scroll reset - let the marketplace component handle restoration
      return;
    }
    
    // Immediate, synchronous scroll to top - executes before browser paint
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
